import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/status/update/many/user.status.update.many.mutation.gql"
import type {
  UserStatusUpdateManyMutation,
  UserStatusUpdateManyMutationVariables,
} from "@/v2-backoffice-client/user/status/update/many/__types__/user.status.update.many.mutation"

type Options = MutationHookOptions<
  UserStatusUpdateManyMutation,
  UserStatusUpdateManyMutationVariables
>

export function useUserStatusUpdateManyMutation(options?: Options) {
  return useMutation<
    UserStatusUpdateManyMutation,
    UserStatusUpdateManyMutationVariables
  >(mutation, options)
}
